import { Tooltip } from '@saucelabs/ds-tooltip';
import { Typography } from '@saucelabs/ds-typography';
import React, { Fragment } from 'react';

import { ProgressData } from './utils';

export enum ProgressBarColor {
  GREEN = 'GREEN',
  GREEN_LIGHT = 'GREEN_LIGHT',
  ORANGE = 'ORANGE',
  RED = 'RED',
  GRAY = 'GRAY'
}

type Props = {
  data: ProgressData,
  cntClass?: string,
  totalLabel?: string,
  showStats?: boolean
}

export const ProgresBarStyles: {[key in ProgressBarColor]: {bar: string, text: string}} = {
  GREEN: {
    bar: 'bg-green-400',
    text: 'text-green-400',
  },
  GREEN_LIGHT: {
    bar: 'bg-green-50',
    text: 'text-green-50',
  },
  ORANGE: {
    bar: 'bg-orange-600',
    text: 'text-orange-600',
  },
  RED: {
    bar: 'bg-red-600',
    text: 'text-red-600',
  },
  GRAY: {
    bar: 'bg-gray-300',
    text: 'text-gray-300',
  },
};

const ProgressBar = ({ data, showStats = true, totalLabel = 'Snapshots', cntClass = 'flex items-center' }: Props) => {
  const stats = [{
    label: totalLabel,
    value: data.total,
    new: 0,
    color: ProgressBarColor.GRAY,
    showInStats: true,
  }, ...data.items].filter((item) => item.showInStats);

  const getNewLabel = (value?: number) => (value ? `(${value} new)` : '');

  return !data.total ? (
    <Typography
      className="text-medium-emphasis ml-auto"
      variant="body"
    >
      No snapshots
    </Typography>
  ) :
    (
      <div
        className={cntClass}
        data-qa="build-progress"
      >
        <Tooltip
          placement="top"
          title={(
            <div>
              {data.items.map((item) => (
                <Typography
                  key={item.label}
                  variant="body-small"
                >
                  <span className={`mr-1 font-semibold ${ProgresBarStyles[item.color].text}`}>{item.value}</span>
                  <span className="font-normal">
                    {item.label}
                    {' '}
                    {getNewLabel(item.new)}
                  </span>
                </Typography>
              ))}

            </div>
          )}
        >
          <div className="flex flex-col flex-grow">
            <div className="flex flex-grow justify-self-stretch rounded overflow-hidden h-1.5 w-24 ml-auto">
              {data.items.map((item) => (item.value ? (
                <div
                  key={item.label}
                  className={`flex ${ProgresBarStyles[item.color].bar}`}
                  style={{ width: `${(item.value / data.total) * 100}%` }}
                />
              ) : null))}
            </div>
            <div className="flex ml-auto mt-0.25 whitespace-nowrap">
              {showStats && stats.map(((item, i) => (item.showInStats ? (
                <Fragment key={item.label}>
                  {!!i && <span className="text-base mx-1">|</span>}
                  <Typography
                    className="text-medium-emphasis flex items-center font-semibold mr-0.5"
                    variant="body"
                  >
                    {item.value}
                  </Typography>
                  <Typography
                    className="text-medium-emphasis flex items-center"
                    variant="body"
                  >
                    {item.label}
                    {' '}
                    {getNewLabel(item.new)}
                  </Typography>
                </Fragment>
              ) :
                null)))}
            </div>
          </div>
        </Tooltip>
      </div>
    );
};

export default ProgressBar;
